export default __webpack_public_path__ + "static/973-6da7741406391d6a035038840e780dad.gif";